import _ from 'lodash'
import { ItList } from 'types/graphql'

import { BrandColor } from 'src/types'

import { BuyOptions } from '../../..'
import AffiliateUnlock from '../AffiliateUnlock/AffiliateUnlock'

import BuyButton from './BuyButton/BuyButton'
import UnlockWithEmail from './UnlockWithEmail/UnlockWithEmail'

const Body: React.FC<{
  withEmailPaywall: boolean
  emailElRef: React.MutableRefObject<HTMLInputElement>
  itList: ItList
  buy(options?: BuyOptions): unknown
  buyIsLoading: boolean
  brandColor: BrandColor
}> = ({
  withEmailPaywall,
  emailElRef,
  itList: { id, price, name, creator, relationship },
  buy,
  buyIsLoading,
  brandColor,
}) => {
  if (withEmailPaywall) {
    return (
      <UnlockWithEmail
        emailElRef={emailElRef}
        brandColor={brandColor}
        creator={creator}
        title={name}
        itListId={id}
      />
    )
  } else if (relationship === 'affiliate' && price) {
    return (
      <AffiliateUnlock
        buy={buy}
        buyIsLoading={buyIsLoading}
        brandColor={brandColor}
      />
    )
  }
  return (
    <BuyButton
      price={price}
      creatorFirstName={creator.firstName}
      buy={buy}
      buyIsLoading={buyIsLoading}
      brandColor={brandColor}
    />
  )
}

export default Body
